import { render, staticRenderFns } from "./StatusOrderDetailsPopup.vue?vue&type=template&id=798bc9f7&scoped=true"
import script from "./StatusOrderDetailsPopup.vue?vue&type=script&lang=js"
export * from "./StatusOrderDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./StatusOrderDetailsPopup.vue?vue&type=style&index=0&id=798bc9f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798bc9f7",
  null
  
)

export default component.exports